const whiteList = ["/oauth/Callback"];

export const inWhiteList = (path) => {
  return !!whiteList.find((item) => item === path);
};

export default whiteList;
